var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.25C16.4398 1.25 17.7801 1.95121 18.6155 3.48639L18.75 3.75H25C25.5804 3.75 26.1607 4.2889 26.2407 4.8663L26.25 5V26.25C26.25 26.8304 25.7111 27.4107 25.1337 27.4907L25 27.5H5C4.41964 27.5 3.83929 26.9611 3.75934 26.3837L3.75 26.25V5C3.75 4.41964 4.2889 3.83929 4.8663 3.75934L5 3.75H11.25C12.0668 2.03129 13.4757 1.25 15 1.25ZM22.5 6.25H7.5C6.875 6.25 6.25 6.875 6.25 7.5V23.75C6.25 24.375 6.875 25 7.5 25H20L23.75 20.625V7.5C23.75 6.875 23.125 6.25 22.5 6.25ZM20.8002 10.2898C21.2898 10.6977 21.3885 11.4007 21.0532 11.9236L20.9603 12.0503L14.7103 19.5503C14.2733 20.0746 13.5059 20.1454 12.9823 19.7368L12.8661 19.6339L9.11612 15.8839C8.62796 15.3958 8.62796 14.6043 9.11612 14.1161C9.56672 13.6655 10.2758 13.6309 10.7661 14.0122L10.8839 14.1161L13.665 16.8963L19.0397 10.4498C19.4817 9.91945 20.2699 9.8478 20.8002 10.2898Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.3d1f441b.svg";
export { ForwardRef as ReactComponent };